// extracted by mini-css-extract-plugin
export var orderDetails = "_vb-2";
export var orderImage = "_vb-1";
export var orderMeta = "_vb-3";
export var orderSummary = "_vb-0";
export var rightArrow = "_vb-4";